import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { getReactionsQueryInfo } from './utils/data.ts';

export function preloadPageReactions({ pageId, containerId }) {
	const { query: reactionsQuery, queryVariables } = getReactionsQueryInfo(
		false,
		pageId,
		containerId,
	);

	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: reactionsQuery,
		variables: queryVariables,
	});
}
